import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import config from "../config/index";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "Home",
      description: "Welcome to Vista View Condos - Upgraded condos with amazing views in Spanish Fork. Explore our floor plans, amenities, and schedule a tour today.",
    },
  },
  {
    path: "/availability",
    name: "Availability",
    component: () =>
      import(
        /* webpackChunkName: "availability" */ "../views/Availability.vue"
      ),
    meta: {
      title: "Availability",
      description: "Check current unit availability at Vista View Condos. View available units, floor plans, and join our waiting list for upcoming openings.",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import(/* webpackChunkName: "faq" */ "../views/FAQ.vue"),
    meta: {
      title: "FAQ",
      description: "Frequently asked questions about Vista View Condos. Learn about our amenities, pet policies, application process, and more.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const nav = document.querySelector("#nav");
      return {
        el: to.hash,
        top: nav.scrollHeight,
        behavior: "smooth",
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach((to) => {
  nextTick(() => {
    // Use meta.title if available, otherwise fallback to route name
    const pageTitle = to.meta?.title || to.name;
    document.title = `${config.communityName} - ${pageTitle}`;

    // Update or create meta description tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (to.meta?.description) {
      if (metaDescription) {
        metaDescription.setAttribute("content", to.meta.description);
      } else {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        metaDescription.setAttribute("content", to.meta.description);
        document.getElementsByTagName("head")[0].appendChild(metaDescription);
      }
    }
  });
});

export default router;
